import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

// Actions
import * as checklistV2Actions from '../../../../actions/ChecklistV2Actions';
import * as NotificationActions from '../../../../actions/NotificationActions';

import ChecklistAddTask from './ChecklistAddTask';

export const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: formData => dispatch(checklistV2Actions.createTask(formData))
    .then((taskJson) => {
      dispatch(checklistV2Actions.fetchChecklist(false));
      return taskJson;
    })
    .then((taskJson) => {
      const taskId = taskJson.id;
      dispatch(NotificationActions.confirmation({ message: 'Task Added' }));

      dispatch(checklistV2Actions.selectTask(taskId));
      browserHistory.push(`${checklistV2Actions.CHECKLIST_URL}/${taskId}`);
      // if filters are active, we call filter tasks to update list state
      dispatch(checklistV2Actions.maybeFilterTasks());
      ownProps.onClose();
    }),
});

export default connect(null, mapDispatchToProps)(ChecklistAddTask);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistAddTask/index.js